import {Component, OnInit} from '@angular/core';
import {Model} from '../../app.model';
import {CountryService} from '../../country/country.service';
import {Company} from "../../company/company.model";
import {Country} from "../../country/country.model";
import {AutorunComponent} from "@myshared/autorun.component";
import {CustomerService} from "../customer.service";
import {Router} from "@angular/router";
import {Customer} from "../customer.model";
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-add-customer',
    templateUrl: './add-customer.component.html',
    styleUrls: [],
    standalone: false
})
export class AddCustomerComponent extends AutorunComponent implements OnInit {
  company: Company;
  countries: Country[];

  constructor(private m: Model, private countryService: CountryService, private customerService: CustomerService, private router: Router) { super(); }

  async ngOnInit() {
    this.autorun(() => {
      this.countries = this.m.country.countries;
    })
    this.countryService.refresh();
  }

  onSubmit(form: FormEmitter<Customer>) {
    const customer = form.data;
    this.customerService.create(customer).subscribe({
      next: () => {
        this.router.navigate(['/customers'])
      },
      error: (e) => {
        console.log('Error!', e)
      }
    });
  }
}
